module.exports = __webpack_public_path__ + "images/clear_icon.svg";